import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddLocationActions from './add-location.actions';

export const addLocationFeatureKey = 'addLocation';

export interface AddLocationState {
   callState: CallState;
}

export const initialState: AddLocationState = {
   callState: LoadingState.Init,
};

const addLocationReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddLocationActions.createLocation, AddLocationActions.createLocationAndAddAnother, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddLocationActions.createLocationSuccess, AddLocationActions.createLocationAndAddAnotherSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddLocationActions.createLocationFailure, AddLocationActions.createLocationAndAddAnotherFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddLocationState | undefined, action: Action) {
   return addLocationReducer(state, action);
}
